var React = require('react');

function PlayIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M68 39L.5 77.971V.03L68 39z","fill":"#E6E5E1"}));
}

PlayIconInline.defaultProps = {"viewBox":"0 0 68 78","fill":"none"};

module.exports = PlayIconInline;

PlayIconInline.default = PlayIconInline;
